import { Accordion, AccordionProps as MantineAccordionProps } from '@mantine/core';
import { IconChevronDown } from 'ui-icons';

import classes from './Accordion.module.css';

const AccordionDefaultProps: Partial<MantineAccordionProps> = {
  variant: 'separated',
  chevron: <IconChevronDown />,
};

const AccordionDefaults = Accordion.extend({
  defaultProps: AccordionDefaultProps,
  classNames: {
    item: classes.item,
    control: classes.control,
    content: classes.content,
    label: classes.label,
    panel: classes.panel,
  },
});

export { Accordion, AccordionDefaults };
export type { MantineAccordionProps as AccordionProps };
